import { z } from 'zod';
import { IpAddress, IsoTime, ServerId, Severity } from './basics.js';
/**
 * Sent only when something noteworthy happens (knowledge doc section 6).
 *
 * `id` is generated by the agent and carries a unique constraint in the database,
 * so a retried batch is ignored rather than duplicated (reliability rule: safe retries).
 */
export const GuardEvent = z.object({
    /** Version 7 for the same time-ordering reason as a metric's id. */
    id: z.uuidv7(),
    serverId: ServerId,
    category: z.string().min(1).max(32),
    severity: Severity,
    message: z.string().min(1).max(500),
    sourceIp: IpAddress.optional(),
    path: z.string().max(4096).optional(),
    actionTaken: z.string().max(200).optional(),
    /** Original source data. The API caps its stored size. */
    raw: z.unknown().optional(),
    occurredAt: IsoTime,
});
/** What a module emits: the core adds `id` and `serverId`. */
export const ModuleEvent = GuardEvent.omit({ id: true, serverId: true });
//# sourceMappingURL=event.js.map